import { render, staticRenderFns } from "./Frage_15.vue?vue&type=template&id=53e90342&"
import script from "./Frage_15.vue?vue&type=script&lang=js&"
export * from "./Frage_15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports